// Backend calls for the database backup page. The contract is the one agreed
// with the backend side (evory-dev-english, DbBackup* classes): /api/db-backups.

import axios from 'axios';

const jsonHeaders = {
   withCredentials: true,
   headers: { 'Content-Type': 'application/json' },
};

export function getBackupStatus() {
   return axios.get('/api/db-backups/status', { withCredentials: true });
}

export function getBackupConfig() {
   return axios.get('/api/db-backups/config', { withCredentials: true });
}

export function saveBackupConfig(config) {
   return axios.put('/api/db-backups/config', JSON.stringify(config), jsonHeaders);
}

export function getBackupRuns(limit = 50) {
   return axios.get('/api/db-backups/runs', { params: { limit }, withCredentials: true });
}

export function getBackupRun(id) {
   return axios.get('/api/db-backups/runs/' + id, { withCredentials: true });
}

// Starts a manual run; answers 202 with the new run, 409 when one is running.
export function startBackupRun() {
   return axios.post('/api/db-backups/runs', JSON.stringify({}), jsonHeaders);
}

export function deleteBackupRun(id) {
   return axios.delete('/api/db-backups/runs/' + id, { withCredentials: true });
}

export function backupRunFileUrl(id) {
   return '/api/db-backups/runs/' + id + '/file';
}
